<div
  #dropdownContainer
  class="cm-typeahead-dropdown"
  [ngStyle]="getDropdownStyle()"
  role="listbox"
  aria-label="Autocomplete suggestions"
>
  <div class="suggestion-list">
    <div
      *ngFor="
        let suggestion of getVisibleSuggestions();
        let i = index;
        trackBy: trackBySuggestion
      "
      class="suggestion-item"
      [class.selected]="i === selectedIndex"
      [class.suggestion-keyword]="suggestion.type === 'keyword'"
      [class.suggestion-value]="suggestion.type !== 'keyword'"
      role="option"
      [attr.aria-selected]="i === selectedIndex"
      [attr.data-index]="i"
      (click)="onSuggestionClick(suggestion, i)"
      (mouseenter)="onSuggestionHover(i)"
    >
      <div class="suggestion-content">
        <div class="suggestion-label">{{ suggestion.label }}</div>
        <div *ngIf="suggestion.info" class="suggestion-info">
          {{ suggestion.info }}
        </div>
      </div>

      <div *ngIf="suggestion.type" class="suggestion-type">
        {{ suggestion.type }}
      </div>
    </div>
  </div>

  <!-- Loading state (for future use) -->
  <div *ngIf="suggestions.length === 0" class="no-suggestions">
    No suggestions found
  </div>
</div>
